export default{
  isAuthenticated: () => {
    var token = localStorage.getItem("authToken");
    
    if(token != null) return true;
    return false;
  }
};
